<template>
  <q-page padding>
    <PageHeader>
      <template #title> Gestão de Catálogo </template>
      <template #actions>
        <span class="q-ml-sm text-brand-5 text-h6">
          - veja e gerencie os produtos deste catálogo
        </span>
      </template>
    </PageHeader>
    <div>
      <q-table
        flat
        table-header-class="bg-accent text-width-bold"
        title="Todos os produtos criados"
        :rows="rows"
        :loading="disable"
        :columns="columns"
        v-model:pagination="pagination"
        class="q-mt-md tabela-tamanho-fixo"
        row-key="name"
        dense
        hide-pagination
        @request="handleRequest"
        selection="multiple"
        v-model:selected="selected"
      >
        <template v-slot:top-right>
          <q-input
            outlined
            dense
            rounded
            debounce="300"
            v-model="filter"
            placeholder="Filtrar por nome"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </template>
        <template #body-cell-categoria="props">
          <q-td style="white-space: pre-line">
            <div>
              {{
                props.row.contracts.find((value) => {
                  return value.id == id;
                })
                  ? props.row.contracts.find((value) => {
                      return value.id == id;
                    }).pivot?.product_category?.code
                  : ""
              }}
            </div>
          </q-td>
        </template>
        <template #body-cell-ca="props">
          <q-td>
            <div>
              {{
                props.row.contracts.find((value) => {
                  return value.id == id;
                }) &&
                props.row.contracts.find((value) => {
                  return value.id == id;
                }).pivot.ca
                  ? props.row.contracts.find((value) => {
                      return value.id == id;
                    }).pivot.ca.code +
                    " - " +
                    `${props.row.contracts
                      .find((value) => {
                        return value.id == id;
                      })
                      .pivot.ca?.expires_in?.split(" ")[0]
                      .split("-")
                      .reverse()
                      .join("/")}` +
                    " " +
                    `(${
                      props.row.contracts.find((value) => {
                        return value.id == id;
                      }).pivot.ca.status
                    })`
                  : ""
              }}
            </div>
          </q-td>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>

    <div v-for="(row, index) in selected" :key="index" class="q-mt-xl">
      <h6 class="h6-selecionados">Produto Numero: {{ index + 1 }}</h6>

      <section class="row">
        <div class="column q-mt-sm q-ml-sm col-md-2 col-2">
          <span>Código</span>
          <q-input
            outlined
            :disable="true"
            dense
            v-model="row.code"
            placeholder="Num. Pedido"
          />
        </div>
        <div class="column q-mt-sm q-ml-sm col-md-2 col-2">
          <span>Descrição</span>

          <q-input
            outlined
            :disable="true"
            dense
            v-model="row.description"
            placeholder="Num. Pedido"
          />
        </div>
        <div class="column q-mt-sm col-md-2 q-ml-sm col-2">
          <span>Categoria</span>
          <q-select
            :options="categoriasList"
            dense
            outlined
            label="Categoria"
            option-label="code"
            :option-value="(item) => (item === null ? null : item.id)"
            v-model="row.contracts[0].pivot.product_category.id"
            map-options
          />
        </div>
        <div class="column q-mt-sm col-md-2 q-ml-sm col-2">
          <span>CA</span>
          <q-select
            v-if="
              row.contracts.length != 0 &&
              row.contracts[0].pivot &&
              row.contracts[0].pivot.ca
            "
            v-model="row.contracts[0].pivot.ca.code"
            dense
            outlined
            style="width: 100%; max-width: 100%"
            label="Digite o CA para pesquisar"
            :options="caList"
            option-label="code"
            option-value="id"
            use-input
            map-options
            @filter="filterFnCA"
          >
          </q-select>

          <q-select
            v-else
            v-model="row.ca"
            dense
            outlined
            style="width: 100%; max-width: 100%"
            label="Digite o CA para pesquisar"
            :options="caList"
            option-label="code"
            option-value="id"
            use-input
            map-options
            @filter="filterFnCA"
          >
            <template v-slot:option="scope">
              <div
                class="hover-select"
                style="height: 48px; cursor: pointer; padding: 8px 16px"
                v-bind="scope.itemProps"
                v-on="scope.itemEvents"
              >
                {{ scope.opt.code }} - {{ scope.opt.status }}
              </div>
            </template>
          </q-select>
        </div>
        <div class="column q-mt-sm q-ml-sm col-md-2 col-2">
          <span>Estoque Min.</span>
          <q-input
            outlined
            dense
            v-model="row.minimal_amount"
            placeholder="Estoque Min."
          />
        </div>
        <div class="column q-mt-sm q-ml-sm col-md-1 col-2">
          <span>Estoque Max.</span>
          <q-input
            outlined
            dense
            v-model="row.max_amount"
            placeholder="Estoque Max."
          />
        </div>
        <div class="column q-mt-sm q-ml-sm col-md-2 col-2">
          <span>Ponto de Reposição</span>
          <q-input
            outlined
            dense
            v-model="row.replacement_amount"
            placeholder="Ponto de Reposição"
          />
        </div>
        <div class="column q-mt-sm q-ml-sm col-md-2 col-2">
          <span>Consumo Estimado</span>
          <q-input
            outlined
            dense
            v-model="row.consumo_estimado"
            placeholder="Consumo Estimado"
            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
          />
        </div>
        <div class="column q-mt-sm q-ml-sm col-md-2 col-2">
          <span>Part#</span>
          <q-input
            outlined
            dense
            v-model="row.part_number"
            placeholder="Part"
          />
        </div>
        <div class="column q-mt-sm q-ml-sm col-md-2 col-2">
          <span>Fabricante</span>
          <q-input
            outlined
            dense
            v-model="row.fabricante"
            placeholder="Fabricante"
          />
        </div>
        <div class="column q-mt-sm q-ml-sm col-md-2 col-2">
          <span>CFOP</span>
          <q-input outlined dense v-model="row.cfop" placeholder="CFOP" />
        </div>
        <div class="column q-mt-sm q-ml-sm col-md-1 col-1">
          <span>NCM</span>
          <q-input outlined dense v-model="row.ncm" placeholder="NCM" />
        </div>
        <div class="column q-mt-sm q-ml-sm col-md-2 col-2">
          <span>Cest</span>
          <q-input outlined dense v-model="row.cest" placeholder="Cest" />
        </div>
        <div class="column q-mt-sm q-ml-sm col-md-2 col-2">
          <span>ICMS</span>
          <q-input
            outlined
            dense
            v-model="row.icms"
            placeholder="ICMS"
            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
          />
        </div>
        <div class="column q-mt-sm q-ml-sm col-md-2 col-2">
          <span>PIS</span>
          <q-input
            outlined
            dense
            v-model="row.pis"
            placeholder="PIS"
            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
          />
        </div>
        <div class="column q-mt-sm q-ml-sm col-md-2 col-2">
          <span>COFINS</span>
          <q-input
            outlined
            dense
            v-model="row.cofins"
            placeholder="COFINS"
            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
          />
        </div>
        <div class="column q-mt-sm q-ml-sm col-md-2 col-2">
          <span>Preço C/ Impostos</span>
          <q-input
            outlined
            dense
            type="number"
            v-model="row.price"
            placeholder="Preço C/ Impostos"
          />
        </div>
      </section>

      <!--<q-table
        flat
        table-header-class="bg-accent text-width-bold"
        title="Produtos Selecionados"
        :rows="selected"
        :loading="disable"
        dense
        :columns="columns2"
        class="q-mt-md"
        row-key="name"
        :rows-per-page-options="[0]"
      >
        <template #body-cell-categoria="props">
          <q-td style="white-space: pre-line">
            <div style="width: 160px">
              <q-select
                :options="categoriasList"
                dense
                outlined
                label="Categoria"
                option-label="code"
                :option-value="(item) => (item === null ? null : item.id)"
                v-model="props.row.product_category_id"
                map-options
              />
            </div>
          </q-td>
        </template>
        <template #body-cell-ca="props">
          <q-td>
            <div>
              {{
                props.row.contracts.find((value) => {
                  return value.id == id;
                }) &&
                props.row.contracts.find((value) => {
                  return value.id == id;
                }).pivot.ca
                  ? props.row.contracts.find((value) => {
                      return value.id == id;
                    }).pivot.ca.code
                  : ""
              }}
            </div>
          </q-td>
        </template>
        <template #body-cell-minimo="props">
          <q-td>
            <div style="width: 160px">
              <q-input dense outlined v-model="props.row.minimal_amount" />
            </div>
          </q-td>
        </template>
        <template #body-cell-max="props">
          <q-td>
            <div style="width: 160px">
              <q-input dense outlined v-model="props.row.max_amount" />
            </div>
          </q-td>
        </template>
        <template #body-cell-reposicao="props">
          <q-td>
            <div style="width: 160px">
              <q-input dense outlined v-model="props.row.replacement_amount" />
            </div>
          </q-td>
        </template>

        <template #body-cell-estimado="props">
          <q-td>
            <div style="width: 160px">
              <q-input
                dense
                outlined
                v-model="props.row.consumo_estimado"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
              />
            </div>
          </q-td>
        </template>
        <template #body-cell-part="props">
          <q-td>
            <div style="width: 160px">
              <q-input dense outlined v-model="props.row.part_number" />
            </div>
          </q-td>
        </template>
        <template #body-cell-fabricante="props">
          <q-td>
            <div style="width: 160px">
              <q-input dense outlined v-model="props.row.fabricante" />
            </div>
          </q-td>
        </template>

        <template #body-cell-cfop="props">
          <q-td>
            <div style="width: 160px">
              <q-input dense outlined v-model="props.row.cfop" />
            </div>
          </q-td>
        </template>

        <template #body-cell-ncm="props">
          <q-td>
            <div style="width: 160px">
              <q-input dense outlined v-model="props.row.ncm" />
            </div>
          </q-td>
        </template>

        <template #body-cell-cest="props">
          <q-td>
            <div style="width: 160px">
              <q-input dense outlined v-model="props.row.cest" />
            </div>
          </q-td>
        </template>

        <template #body-cell-icms="props">
          <q-td>
            <div style="width: 160px">
              <q-input
                dense
                outlined
                v-model="props.row.icms"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
              />
            </div>
          </q-td>
        </template>

        <template #body-cell-pis="props">
          <q-td>
            <div style="width: 160px">
              <q-input
                dense
                outlined
                v-model="props.row.pis"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
              />
            </div>
          </q-td>
        </template>

        <template #body-cell-cofins="props">
          <q-td>
            <div style="width: 160px">
              <q-input
                dense
                outlined
                v-model="props.row.cofins"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
              />
            </div>
          </q-td>
        </template>

        <template #body-cell-preco="props">
          <q-td>
            <div style="width: 160px">
              <q-input
                dense
                outlined
                v-model="props.row.price"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
              />
            </div>
          </q-td>
        </template>
      </q-table>-->
    </div>

    <section class="q-mt-lg">
      <h6>Fluxo de Aprovação</h6>
      <h6 class="title-tab">Digite o nome, sap ou email para buscar</h6>
      <q-tabs
        v-model="tab"
        dense
        class="text-grey bg-grey-3 q-mt-xl"
        active-color="primary"
        indicator-color="primary"
        align="justify"
        narrow-indicator
      >
        <q-tab name="criador" label="Criador" />
        <q-tab name="solicitante" label="Solicitante" />
        <q-tab name="lider" label="Lider / Gerente Linha" />
        <q-tab name="pg" label="HS&E P&G" />
        <q-tab name="store" label="Store Room P&G" />
        <q-tab name="comprador" label="Comprador" />
      </q-tabs>
      <q-tab-panels v-model="tab" animated>
        <q-tab-panel name="criador">
          <div class="row">
            <span style="font-weight: bold">Criador (Multpex): </span>
            <span class="q-ml-sm">
              {{ $store.state.autenticacao.usuarioLogado.email }}</span
            >
          </div>
        </q-tab-panel>
        <q-tab-panel name="solicitante">
          <q-select
            style="width: 350px"
            v-model="fluxo.solicitante"
            dense
            outlined
            class="select q-mt-sm q-mb-sm"
            label="Digite o nome para pesquisar"
            :options="usersList"
            option-label="name"
            use-input
            @filter="filterFn"
          />
        </q-tab-panel>
        <q-tab-panel name="lider">
          <q-select
            style="width: 350px"
            v-model="fluxo.lider_gerente_linha"
            dense
            outlined
            class="select q-mt-sm q-mb-sm"
            label="Digite o nome para pesquisar"
            :options="usersList"
            option-label="name"
            option-value="id"
            use-input
            map-options
            @filter="filterFn"
          />
        </q-tab-panel>
        <q-tab-panel name="pg">
          <q-select
            style="width: 350px"
            v-model="fluxo.hse"
            dense
            outlined
            class="select q-mt-sm q-mb-sm"
            label="Digite o nome para pesquisar"
            :options="usersList"
            option-label="name"
            option-value="id"
            use-input
            map-options
            @filter="filterFn"
          />
        </q-tab-panel>
        <q-tab-panel name="store">
          <q-select
            style="width: 350px"
            v-model="fluxo.store_room"
            dense
            outlined
            class="select q-mt-sm q-mb-sm"
            label="Digite o nome para pesquisar"
            :options="usersList"
            option-label="name"
            option-value="id"
            use-input
            map-options
            @filter="filterFn"
          />
        </q-tab-panel>
        <q-tab-panel name="comprador">
          <q-select
            style="width: 350px"
            v-model="fluxo.compras"
            dense
            outlined
            class="select q-mt-sm q-mb-sm"
            label="Digite o nome para pesquisar"
            :options="usersList"
            option-label="name"
            option-value="id"
            use-input
            map-options
            @filter="filterFn"
          />
        </q-tab-panel>
      </q-tab-panels>
      <q-input
        type="textarea"
        dense
        outlined
        label="Escreva uma mensagem sobre o produto a ser adicionado..."
        v-model="descricao"
      />

      <q-btn
        @click="Iniciar"
        icon="add"
        class="q-mt-md"
        label="INCIAR FLUXO DE APROVAÇÕES"
        color="positive"
        :disable="verificarAprovadores()"
      />
    </section>
  </q-page>
</template>

<script>
const columns = [
  {
    name: "id",
    label: "Código",
    field: (row) => row.code,
    align: "left",
  },
  {
    name: "usuario_nome",
    label: "Descrição",
    field: (row) => row.description,
    align: "left",
  },
  {
    name: "categoria",
    label: "Categoria",
    field: "categoria",
    align: "left",
  },
  {
    name: "ca",
    label: "CA",
    field: "ca",
    align: "left",
  },
];

const columns2 = [
  {
    name: "id",
    label: "Código",
    field: (row) => row.code,
    align: "left",
  },
  {
    name: "usuario_nome",
    label: "Descrição",
    field: (row) => row.description,
    align: "left",
  },
  {
    name: "categoria",
    label: "Categoria",
    field: "categoria",
    align: "left",
  },
  {
    name: "ca",
    label: "CA",
    field: "ca",
    align: "left",
  },
  {
    name: "minimo",
    label: "Estoque Min.",
    field: "minimo",
    align: "left",
  },
  {
    name: "max",
    label: "Estoque Max.",
    field: "max",
    align: "left",
  },
  {
    name: "reposicao",
    label: "Ponto de Reposição",
    field: "reposicao",
    align: "left",
  },
  {
    name: "estimado",
    label: "Consumo Estimado",
    field: "estimado",
    align: "left",
  },
  {
    name: "part",
    label: "Part#",
    field: "part",
    align: "left",
  },
  {
    name: "fabricante",
    label: "Fabricante",
    field: "fabricante",
    align: "left",
  },
  {
    name: "cfop",
    label: "CFOP",
    field: "cfop",
    align: "left",
  },
  {
    name: "ncm",
    label: "NCM",
    field: "ncm",
    align: "left",
  },
  {
    name: "cest",
    label: "CEST",
    field: "cest",
    align: "left",
  },
  {
    name: "icms",
    label: "ICMS",
    field: "icms",
    align: "left",
  },
  {
    name: "pis",
    label: "PIS",
    field: "pis",
    align: "left",
  },
  {
    name: "cofins",
    label: "COFINS",
    field: "cofins",
    align: "left",
  },
  {
    name: "preco",
    label: "Preço C/ Impostos",
    field: "preco",
    align: "left",
  },
];

import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { ref, onMounted, computed, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import PageHeader from "../../../../components/PageHeader.vue";

export default {
  components: {
    PageHeader,
  },
  setup() {
    const store = useStore();
    const rows = ref([]);
    const quasar = useQuasar();
    const route = useRoute();
    const router = useRouter();
    const id = route.params.id;
    const disable = ref(true);
    const selected = ref([]);
    const searchUser = ref("");
    const time = ref();
    const fluxo = ref({
      solicitante: null,
      criador: store.state.autenticacao.idBase,
      lider_gerente_linha: null,
      hse: null,
      store_room: null,
      compras: null,
    });
    const descricao = ref("");
    const tab = ref("criador");
    const categoriasList = ref([]);
    const caList = ref([]);
    const usersList = ref([]);
    const filter = ref("");
    const filtros = ref({
      dataInicial: "",
      dataFinal: new Date()
        .toLocaleString("pt-br")
        .split(" ")[0]
        .replace(",", " "),
      solicitante: "",
    });
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 15,
    });
    const getDados = async (page = 0, rowsPerPage = 15) => {
      try {
        let response = await store.dispatch("wf/listarProdutos", {
          page,
          per_page: rowsPerPage,
          search: filter.value,
        });
        rows.value = response.data.results.data.map((value) => {
          if (
            value.contracts.length == 0 ||
            value.contracts[0]?.pivot?.product_category_id == null
          ) {
            return {
              ...value,
              contracts: [
                { id: value.id, pivot: { product_category: { id: "" } } },
              ],
            };
          } else {
            return value;
          }
        });

        pagination.value.rowsPerPage = response.data.results.per_page;
        pagination.value.rowsNumber = response.data.results.total;

        disable.value = false;
      } catch (error) {
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getDados);

    const getCategorias = async () => {
      try {
        let response = await store.dispatch("wf/getCategorias");
        categoriasList.value = response.data.results.data;
      } catch (error) {
        quasar.notify({
          message: "Erro a o procurar categorias",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getCategorias);

    const getCA = async (val) => {
      try {
        let response = await store.dispatch("wf/getCA", {
          code: val,
        });
        caList.value = response.data.results.data;
      } catch (error) {
        quasar.notify({
          message: "Erro a o procurar categorias",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getCA);

    const getUsers = async (val) => {
      try {
        let response = await store.dispatch("wf/getUsers", {
          search: val,
        });
        usersList.value = response.data.results.data;
      } catch (error) {
        quasar.notify({
          message: "Erro a o procurar usuarios",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getUsers);

    const handleRequest = async () => {
      getDados(pagination.value.page, pagination.value.rowsPerPage);
    };

    const Iniciar = async () => {
      let products = [];
      products = selected.value.map((e) => {
        return {
          product_id: e.id,
          ...e,
          product_category_id: e.contracts[0]?.pivot?.product_category?.id?.id,
        };
      });

      try {
        for (const chave in fluxo.value) {
          if (chave != "criador") {
            fluxo.value[chave] = fluxo.value[chave].id;
          }
        }

        await store.dispatch("wf/criarRegistro", {
          contract_id: id,
          fields: { message: descricao.value },
          products: products,
          workflow_users: fluxo.value,
        });

        quasar.notify({
          message: "Registro criado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        router.push({ name: "catalogo-wf-acompanhamento", params: { id: id } });
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro a o criar registro",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const verificarAprovadores = () => {
      for (const chave in fluxo.value) {
        if (fluxo.value[chave] == null) {
          return true;
        }
      }
      return false;
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => filter.value,
      () => {
        getDados();
      }
    );

    watch(
      () => searchUser.value,
      () => {
        getUsers();
      }
    );

    return {
      rows,
      columns,
      getDados,
      handleRequest,
      tipoDocumento: [
        { id: 0, nome: "FICHA DE EPI", value: "ficha_epi" },
        { id: 1, nome: "RELATÓRIOS", value: "relatorio" },
        { id: 2, nome: "Consumo", value: "consumo" },
      ],
      myLocale: {
        /* starting with Sunday */
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      filtros,
      pagination,
      disable,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      selected,
      filter,
      id,
      columns2,
      categoriasList,
      tab,
      fluxo,
      usersList,
      time,
      searchUser,
      Iniciar,
      descricao,
      verificarAprovadores,
      filterFn(val, update, abort) {
        clearTimeout(time.value);
        if (val.length < 1) {
          abort();
          return;
        }
        usersList.value = [];
        time.value = setTimeout(() => {
          getUsers(val);
        }, 1000);

        setTimeout(() => {
          update();
        }, 1500);

        setTimeout(() => {
          update();
        }, 1000);
      },
      filterFnCA(val, update, abort) {
        clearTimeout(time.value);
        if (val.length < 1) {
          abort();
          return;
        }
        usersList.value = [];
        time.value = setTimeout(() => {
          getCA(val);
        }, 1000);

        setTimeout(() => {
          update();
        }, 1500);

        setTimeout(() => {
          update();
        }, 1000);
      },
      caList,
    };
  },
};
</script>

<style scoped>
.title-tab {
  font-weight: normal;
  margin: 0;
}

.title-tab-base {
  margin-bottom: 15px;
}

.h6-selecionados {
  margin: 0;
}

.hover-select {
  transition: 0.2s linear;
}

.hover-select:hover {
  background-color: #dddddd;
}
</style>
